import { render, staticRenderFns } from "./bookingSummaryComponent.vue?vue&type=template&id=5e355076&"
import script from "./bookingSummaryComponent.vue?vue&type=script&lang=js&"
export * from "./bookingSummaryComponent.vue?vue&type=script&lang=js&"
import style0 from "./bookingSummaryComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "bookingSummaryComponent.vue"
export default component.exports